// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });




    $('.-box-checkbox').click(function(e) {
      var wrap = $(this).closest('.-options-wrap');
      var checkboxes = wrap.find('input:checkbox:checked');
      var checkboxesLength = checkboxes.length;

      const checkboxElements = Array.from(checkboxes);
      const docs = [];  
      checkboxElements.forEach(element => { 
        var getID = element.id;
        docs.push(getID);
      })

      var docsComma = docs.toString();
      /*console.log(docsComma);*/
      var deleteTrigger = $('#delete-items').closest('button')[0];
      deleteTrigger.setAttribute('data-items', docsComma);
      /*console.log(docs);*/

      if (checkboxesLength > 0) {
        var label = '('+checkboxesLength;
        label += (checkboxesLength > 1?' projetos':' projeto');
        label += ')';
        $('.-options-manage').removeClass('empty');
      }else{
        var label = '';
        $('.-options-manage').addClass('empty');
      }
      
      $('#delete-items').text(label);
    });

    /*data filters*/
    $('[data-fill]').click(function(e) {
        e.preventDefault();
        var toggleVal = $(this).data('fill');
        var dataParent = $(this).closest('[data-filters]');
        var parent = $('#'+dataParent.data('filters'));

        dataParent.find('button').removeClass('active');
        $(this).addClass('active');
        
        if (toggleVal == '*') {
          parent.find('[data-filter]').removeClass('-fill-on');
          parent.find('[data-filter]').removeClass('-fill-off');
        }else{
          parent.find('[data-filter]').removeClass('-fill-on');
          parent.find('[data-filter]').addClass('-fill-off');
          parent.find('[data-filter="'+toggleVal+'"]').addClass('-fill-on');
        }
    });

    /*data filters inside*/
    $('[data-options]').click(function(e) {
        e.preventDefault();
        var toggleVal = $(this).data('options');
        /*var dataParent = $(this).closest('[data-filters]');*/
        var parent = $('#filtering-sub');
        var level = $(this).data('level');
        var tax = $(this).data('options');
        var taxReference = $(this).data('refer');


        $('.-options-filter').removeClass('-options-filter-hide');

        if (typeof level !== 'undefined' && level !== false){
          console.log('appended: '+level);
          $('[data-return]').attr( 'data-return', level )
        }
        if (typeof tax !== 'undefined' && tax !== false){
          console.log('appended: '+tax);
          
          //$('[data-return]').attr( 'data-index', tax )
          if (level > 0) {
            /*$('[data-return]').attr( 'data-tax', taxReference+'-'+level )*/
            $('[data-return]').attr( 'data-tax', taxReference )
          }else{
            $('[data-return]').attr( 'data-tax', tax )

            $('[data-return]').attr( 'data-index', tax )
          }
        }


        /*dataParent.find('button').removeClass('active');
        $(this).addClass('active');*/
        
        /*if (toggleVal == '*') {
          parent.find('[data-filter]').removeClass('-fill-on');
          parent.find('[data-filter]').removeClass('-fill-off');
        }else{*/
          parent.find('[data-options]').removeClass('-fill-on');
          parent.find('[data-options]').addClass('-fill-off');
          parent.find('[data-parent]').removeClass('-fill-on');

          parent.find('[data-parent]').addClass('-fill-off');
          parent.find('[data-parent="'+toggleVal+'"]').addClass('-fill-on');
        /*}*/
    });  

    $('[data-return]').click(function(e) {
        e.preventDefault();
        var parent = $('#filtering-sub'); //console.log($(this));
        /*var returnLevel = $(this).data('return');*/
        var taxReference = $(this).data('refer');
        var returnIndex = $(this).attr('data-index');
        var returnTax = $(this).attr('data-tax');
        var returnLevel = $(this).attr('data-return');
        //var returnLevel = (dataLevel?parseInt(dataLevel):false);

        //console.log('return level: '+returnLevel);
        /*console.log('getter: '+returnLevel);*/

        if (typeof returnLevel !== 'undefined' && returnLevel !== false && returnLevel !== '*' ){          
          //var plusLevel = parseInt(minusLevel) + 1;
          var minusLevel = parseInt(returnLevel) - 1; 
          /*console.log('setter: '+minusLevel);*/
          //minusLevel = ( minusLevel < 0 ? '*' : minusLevel );
          $(this).attr( 'data-return', minusLevel );

          var plusLevel = minusLevel + 1;

            parent.find('[data-level]').removeClass('-fill-on');
            parent.find('[data-level]').addClass('-fill-off');
            //parent.find('[data-level="'+returnLevel+'"]').removeClass('-fill-off');
            
            if (returnLevel == 0) {
              parent.find('[data-level="'+returnLevel+'"]').addClass('-fill-on');  
            }else{
              parent.find('[data-level="'+returnLevel+'"][data-refer="'+returnTax+'"]').addClass('-fill-on');


              $(this).attr( 'data-tax', returnIndex );
            }
            
            
            

            

          if (returnLevel == 0) {
            //console.log('level is zero');
            $('.-options-filter').addClass('-options-filter-hide');
          }

        }else{
          console.log('NOT level attr');

          $('.-options-filter').addClass('-options-filter-hide');
          /*Hide older level*/
          parent.find('[data-parent]').removeClass('-fill-on');
          parent.find('[data-parent]').addClass('-fill-off');

          /*show new level*/
          parent.find('[data-options]').removeClass('-fill-off');
          parent.find('[data-options]').addClass('-fill-on');

        }

        
    });

    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });

    $('[data-form-trigger]').click(function(e) {
      e.preventDefault();
      var dataName = $(this).attr('data-username');
      var dataEmail = $(this).attr('data-usermail');
      var formName = (dataName?dataName:'');
      var formEmail = (dataEmail?dataEmail:'');
      var target = $(this).attr('data-form-trigger');
      var targetEl = $('#'+target);

      var fieldName = targetEl.find('input#receiving-name');
      var fieldEmail = targetEl.find('input#receiving-email');

      fieldName.val(formName);
      fieldEmail.val(formEmail);

      if (targetEl.hasClass('-active')) {
        targetEl.removeClass('-active');  
      }else{
        targetEl.addClass('-active');
      }
    });

    $('[data-dropdown]').click(function(e) {
        e.preventDefault();
        $(this).closest('nav').toggleClass('open');
    })

    /*content tabs*/
    $('.nav-tab-btn').click(function(){
      event.preventDefault();
      var tabTarget = $(this).data('tab');

      if ( $(this).data('bclass') ){
        /*$('body').removeClass( $(this).data('bclass') );*/
        $('body').toggleClass( $(this).data('bclass') );
      }
      /*console.log(tabTarget);*/
      
      $('.tab-content').removeClass('-visible');
      $('.tab-content#'+tabTarget).addClass('-visible');
      $('.nav-tab-btn').removeClass('current');
      $(this).addClass('current');


      /*if ($(window).width() < 769) {
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }*/
    });

    /*Dropdown mobile*/
    $('.tabs-nav-btn').click(function(){
      event.preventDefault();
      var tabTarget = $(this).data('tab');
      console.log(tabTarget);
      
      $('.tabs-content').removeClass('-visible');
      $('.tabs-content#'+tabTarget).addClass('-visible');
      $('.tabs-nav-btn').removeClass('-active');
      $(this).addClass('-active');


      /*if ($(window).width() < 769) {
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }*/
    });


    const togglePassword = document.querySelector("#togglePassword");
    const password = document.querySelector("#password");
    if (togglePassword) {
      togglePassword.addEventListener("click", function () {
          // toggle the type attribute
          const type = password.getAttribute("type") === "password" ? "text" : "password";
          password.setAttribute("type", type);
          
          // toggle the icon
          this.classList.toggle("hidden");
      });
    }

    //password view trigger each
    var togglePassView = document.getElementsByClassName("togglePasswordClass");
    
    var toggleVisibleClass = function() {
      var closer = this.closest('.relative');
      var passwordField = closer.querySelector('input.view-pass'); console.log(passwordField.getAttribute("type"));
      var type = passwordField.getAttribute("type") === "password" ? "text" : "password";
      passwordField.setAttribute("type", type);

      // toggle the icon
      this.classList.toggle("hidden");
    };

    for (var i = 0; i < togglePassView.length; i++) {
        togglePassView[i].addEventListener('click', toggleVisibleClass, false);
    }  

    /*Trigget profile nav*/
    $('.trigger-profile').click(function(e){
      e.preventDefault();
      /*if ($(window).width() < 769) {*/
        $('.-profile-nav').toggleClass('-hidden');
      /*}*/
    });

    /*Trigger notice close*/
    $('.-close-notice').click(function(e){
      e.preventDefault();
      $('body').removeClass('-notice-on');
    });    

    /*Dropdown mobile*/
    $('.dropdown-toggle-hover').click(function(){
      event.preventDefault();
      if ($(window).width() < 769) {
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }
    });

    $(function(){
      // bind change event to select
      $('.dynamic-select').on('change', function () {
          var url = $(this).val(); // get selected value
          if (url) { // require a URL
              window.location = url; // redirect
          }
          return false;
      });
    });  

    //Dashboard Menu trigger
    var asideMenuTrigger = document.getElementsByClassName("-aside-menu-trigger-btn"),
        aside = document.getElementsByClassName("-aside");
    
    var toggleMenuAside = function() {
         /*console.log('main nav offcanvas called')*/
        /*aside[0].classList.toggle("-aside-active");*/
        document.body.classList.toggle("-aside-active");
    };

    for (var i = 0; i < asideMenuTrigger.length; i++) {
        asideMenuTrigger[i].addEventListener('click', toggleMenuAside, false);
    }  


    //Menu trigger
    var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
        menu = document.getElementById("main-nav");
    
    var toggleMenu = function() {
    	   console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("menu-active");
    };

    for (var i = 0; i < menuTrigger.length; i++) {
        menuTrigger[i].addEventListener('click', toggleMenu, false);
    }

    /*Anchor scroll in nav*/
    const navAnchors = document.querySelectorAll(".anchor > a");
     
    for (const anchorNav of navAnchors) {
      anchorNav.addEventListener("click", clickHandler);
    }

    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      e.preventDefault();
      const header = document.querySelector("header").offsetHeight;
      const href = this.getAttribute("href");
      const offsetTop = document.querySelector(href).offsetTop;
      document.body.classList.remove("menu-active");
     
      scroll({
        top: offsetTop-header,
        behavior: "smooth"
      });
    }

    /*Dynamic header on scroll*/
    document.addEventListener('scroll', function(e) {
      lastKnownScrollPosition = window.scrollY;
      WindowWidth = window.innerWidth;
      //console.log(lastKnownScrollPosition);
      wHeight = window.innerHeight;
      mainHeader = document.getElementById('dynamic-header');
      Bodyclasses = document.body.getAttribute('class').split(' ');

      if (mainHeader) { 
       /* if (mainHeader.classList.contains('md-header-blog')) {
          var compareHeight = 60;
        }else{
          var compareHeight = wHeight/3;
        }*/
        var compareHeight = 60;

        if (lastKnownScrollPosition >= compareHeight ) {
          mainHeader.classList.add('-scrolled');
        }else{
          mainHeader.classList.remove('-scrolled');
        }
        
      }
      /*if (WindowWidth < 768 && Bodyclasses.indexOf('-fix-mobile') > -1) {
        e.preventDefault();
        window.scrollTo(0, 0);
      }*/

      /*if (!ticking) {
        window.requestAnimationFrame(function() {
          doSomething(lastKnownScrollPosition);
          ticking = false;
        });

        ticking = true;
      }*/
    });


    /*Tiny slider partners*/
    const tnsSliderMultiple = document.querySelectorAll('.-as-multiple-tns');
    tnsSliderMultiple.forEach(slider => {
          const tnsSliderM = tns({
               container: slider,
               items: 7,
               nav: false,
               gutter: 20,
               autoplayButtonOutput: false,
               autoplay: true,
               controlsPosition: "bottom",
               controlsText: ['<span class="iconify" data-icon="bi:chevron-left"></span>', '<span class="iconify" data-icon="bi:chevron-right"></span>'],
               responsive: {
              320: {
                items: 2,
                nav: true,
                controls: false,
              },
              768: {
                items: 2,
                nav: true,
                controls: false,
              },
              900: {
                items: 7,
                nav: false,
                controls: true,
              }
            }
            
          });
    });

    /*Tiny slider*/
    const tnsCarousel = document.querySelectorAll('.-as-tns');
    tnsCarousel.forEach(slider => {
          const tnsSlider = tns({
               container: slider,
               items: 3,
               controls: false,
               nav: true,
               gutter: 40,
               controlsPosition: "bottom",
               controlsText: ['<span class="iconify" data-icon="bi:chevron-left"></span>', '<span class="iconify" data-icon="bi:chevron-right"></span>'],
               responsive: {
                320: {
                  items: 1,
                },
                768: {
                  items: 2,
                },
                900: {
                  items: 3,
                }
              }
            
          });
    });

    /*Tiny testimoniials Highlight*/
    const tnsPlan = document.querySelector('.-simple-tns');
    if (tnsPlan) {
      const tnsSlider = tns({
        container: tnsPlan,
        /*mode: "gallery",*/
        mouseDrag: true,
        items: 1,
        gutter: 0,
        nav: false,
        navPosition: "bottom",
        controls: true,
        controlsPosition: "bottom",
        controlsText: ['<span class="iconify" data-icon="basil:arrow-up-outline" data-rotate="270deg"></span>Anterior', 'Próximo<span class="iconify" data-icon="basil:arrow-up-outline" data-rotate="90deg"></span>'],
        /*autoplay: false,
        autoplayTimeout: 4000,
        preventScrollOnTouch: "auto",*/
        loop: false,
        autoplayHoverPause: true,
        autoplayButtonOutput: false,
        speed: 300,
        /*responsive: {
          320: {
            items: 1,
            nav: true,
            controls: false,
          },
          768: {
            items: 2,
            nav: true,
            controls: false,
          },
          900: {
            items: 3,
            nav: false,
            controls: true,
          }
        }*/


      });   
    
    }
  
    /*GDPR*/
    document.addEventListener('DOMContentLoaded', function() {
      var cookiebar = document.querySelector('.cookiebar');
      if (cookiebar) {
          var closecookiebar = document.querySelector('.hide-cookiebar-target');
          var acceptcookie = document.querySelector('.accept-cookies');
          var refusecookie = document.querySelector('.refuse-cookies');
          var cookie = readCookie('lgpd_cookie_accept');/*Name of cookie*/
          console.log(cookie);

          if (cookie == "true") {
              cookiebar.style.display = "none";
          }else if (cookie == "false") {
              cookiebar.style.display = "none";
          }else{
              cookiebar.classList.add("no-cookie-yet");
          }

          acceptcookie.addEventListener('click', function(e) {
              if(cookie != "true") {
                cookiebar.style.display = "none";
                createCookie('lgpd_cookie_accept', "true", 7);
              } 
              e.preventDefault();
          });

          if (refusecookie) {
            refusecookie.addEventListener('click', function(e) {
                if(cookie != "true") {
                  cookiebar.style.display = "none";
                  createCookie('lgpd_cookie_accept', "false", 7);
                }
                e.preventDefault();
            });  
          }
          
          if (closecookiebar) {
            closecookiebar.addEventListener('click', function(e) {
                cookiebar.style.display = "none";
                /*if(cookie != "true") {
                  createCookie('lgpd_cookie_accept', "true", 1);
                } */
                e.preventDefault();
            });
          }

      }

      function createCookie(name, value, days) {
          if(days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
          } else var expires = "";
          document.cookie = name + "=" + value + expires + "; path=/"
      }

      function readCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
           
          }
          return null;
      }

      function eraseCookie(name) {
          createCookie(name, "", -1);
      }

    });

    //Function to redirect form after submit
    /*document.addEventListener( 'wpcf7mailsent', function( event ) {
        switch (event.detail.contactFormId ) {
            case '15':
                location = 'http://www./';
                break; 
            default: 
                
        }
    }, false );*/
    //End
    

    /*Input Masks*/
    function runmask() {
      v_obj.value=v_fun(v_obj.value);
    }

    function mask(o,f) {
      v_obj=o;
      v_fun=f;
      setTimeout(runmask(),1)
    }

    function mtel(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
      v = v.replace(/(\d)(\d{4})$/, "$1-$2");
      return v;
    }

    function modate(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "$1/$2");
      v = v.replace(/(\d)(\d{4})$/, "$1/$2");
      return v;
    }

    function mnumbers(v) {
      v = v.replace(/\D/g, "");
      return v;
    }
    function mcep(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{5})(\d)/g, "$1-$2");
      return v;
    }
    function price(v) {
        /*v = v.replace(/\D/g, "");
        v = v.replace(/([0-9]{2})$/g, ",$1");
        v = v.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
        v = v.replace(/([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, ".$1.$2,$3");
        v = v.replace(/([0-9]{3}).([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, ".$1.$2.$3,$4");
        return v;*/
        v = v + '';
        v = parseInt(v.replace(/[\D]+/g, ''));
        v = v + '';
        v = v.replace(/([0-9]{2})$/g, ",$1");

        if (v.length > 6) {
            v = v.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
        }

        if(v == 'NaN') v = '';
        return v;
    }

    function mCpf(v){
      //Remove tudo o que não é dígito
      v=v.replace(/\D/g,"")

      //Coloca um ponto entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{3})(\d)/,"$1.$2")

      //Coloca um ponto entre o terceiro e o quarto dígitos
      //de novo (para o segundo bloco de números)
      v=v.replace(/(\d{3})(\d)/,"$1.$2")

      //Coloca um hífen entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2")

      return v  
    }

    function cpfCnpj(v){
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g,"");
     
        if (v.length < 14) { //CPF   405.604.628-08  43.201.151/0001-99
     
            //Coloca um ponto entre o terceiro e o quarto dígitos
            v=v.replace(/(\d{3})(\d)/,"$1.$2")
     
            //Coloca um ponto entre o terceiro e o quarto dígitos
            //de novo (para o segundo bloco de números)
            v=v.replace(/(\d{3})(\d)/,"$1.$2")
     
            //Coloca um hífen entre o terceiro e o quarto dígitos
            v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
     
        } else { //CNPJ
            //console.log('aki');
            //Coloca ponto entre o segundo e o terceiro dígitos
            v=v.replace(/^(\d{2})(\d)/,"$1.$2")
     
            //Coloca ponto entre o quinto e o sexto dígitos
            v=v.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3")
     
            //Coloca uma barra entre o oitavo e o nono dígitos
            v=v.replace(/\.(\d{3})(\d)/,".$1/$2")
     
            //Coloca um hífen depois do bloco de quatro dígitos
            v=v.replace(/(\d{4})(\d)/,"$1-$2")
     
        }
     
        return v
     
    }
    function maskCC(v){
      //Coloca um ponto entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{4})(\d)/,"$1 $2")

      //Coloca um ponto entre o terceiro e o quarto dígitos
      //de novo (para o segundo bloco de números)
      v=v.replace(/(\d{4})(\d)/,"$1 $2")

      //Coloca um hífen entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{4})(\d{1,2})$/,"$1 $2")

      /*v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
      v = v.replace(/(\d)(\d{4})$/, "$1-$2");*/
      return v;

    }

    var cepValidator = document.getElementsByClassName('mask-cep');
    var cpfValidator = document.getElementsByClassName('mask-cpf');
    var telValidator = document.getElementsByClassName('mask-tel');
    var dateValidator = document.getElementsByClassName('mask-date');
    var priceValidator = document.getElementsByClassName('mask-price');
    var documentValidator = document.getElementsByClassName('mask-doc');
    var onlyNumbers = document.getElementsByClassName('mask-num');
    var ccMask = document.getElementsByClassName('mask-cc-num');

    if(ccMask && ccMask.length != -1){
      for (i = 0; i < ccMask.length; i++) {
        ccMask[i].addEventListener('keyup', function() {
          mask(this, maskCC);
        });
      }
    }
   
    if(onlyNumbers && onlyNumbers.length != -1){
      for (i = 0; i < onlyNumbers.length; i++) {
        onlyNumbers[i].addEventListener('keyup', function() {
          mask(this, mnumbers);
        });
      }
    }

    if(cepValidator && cepValidator.length != -1){
      for (i = 0; i < cepValidator.length; i++) {
        cepValidator[i].addEventListener('keydown', function() {
          mask(this, mcep);
        });
      }
    }
    if(cpfValidator && cpfValidator.length != -1){
      for (i = 0; i < cpfValidator.length; i++) {
        cpfValidator[i].addEventListener('keydown', function() {
          mask(this, mCpf);
        });
      }
    }
    if(telValidator && telValidator.length != -1){
      for (i = 0; i < telValidator.length; i++) {
        telValidator[i].addEventListener('keydown', function() {
          mask(this, mtel);
        });
      }
    }
    if(dateValidator && dateValidator.length != -1){
      for (i = 0; i < dateValidator.length; i++) {
        dateValidator[i].addEventListener('keyup', function() {
          mask(this, modate);
        });
      }
    }

    if(priceValidator && priceValidator.length != -1){
      for (i = 0; i < priceValidator.length; i++) {
        priceValidator[i].addEventListener('keyup', function() {
          mask(this, price);
        });
      }
    }

    if(documentValidator && documentValidator.length != -1){
      for (i = 0; i < documentValidator.length; i++) {
        documentValidator[i].addEventListener('keydown', function() {
          mask(this, cpfCnpj);
        });
      }
    }

    /*CEP autocomplete*/
    $(".cep-autocomplete").blur(function(){
        var address = $(this).closest('form').find(".endereco");
        var number = $(this).closest('form').find(".numero");
        var neighborhood = $(this).closest('form').find(".bairro");
        var city = $(this).closest('form').find(".cidade");
        var state = $(this).closest('form').find(".estado");
        var cep = this.value.replace(/[^0-9]/, "");
        if(cep.length != 8){
            return false;
        }        
        var url = "https://viacep.com.br/ws/"+cep+"/json/";
        $.getJSON(url, function(dadosRetorno){ /*console.log(dadosRetorno);*/
            try{
                address.val(dadosRetorno.logradouro);
                neighborhood.val(dadosRetorno.bairro);
                city.val(dadosRetorno.localidade);
                state.val(dadosRetorno.uf);
                number.focus();
            }catch(ex){}
        });
    });

}(window.jQuery, window, document));